import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconFullSize: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 215.35 215.35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="m7.5 65.088c4.143 0 7.5-3.358 7.5-7.5v-31.978l48.305 48.295c1.465 1.464 3.384 2.196 5.303 2.196 1.92 0 3.84-.732 5.304-2.197 2.929-2.929 2.929-7.678-.001-10.606l-48.307-48.296h31.985c4.142 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-50.089c-4.143 0-7.5 3.358-7.5 7.5v50.087c0 4.141 3.357 7.499 7.5 7.499z" />
      <path d="m207.85 150.262c-4.143 0-7.5 3.358-7.5 7.5v31.979l-49.792-49.792c-2.93-2.929-7.678-2.929-10.607 0s-2.929 7.678 0 10.606l49.791 49.791h-31.977c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h50.086c4.143 0 7.5-3.358 7.5-7.5v-50.084c-.001-4.142-3.359-7.5-7.501-7.5z" />
      <path d="m64.792 139.949-49.787 49.791v-31.978c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v50.086c0 4.142 3.357 7.5 7.5 7.5h50.084c4.142 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-31.978l49.788-49.793c2.929-2.929 2.929-7.678-.001-10.607-2.927-2.928-7.676-2.928-10.606.001z" />
      <path d="m207.85.002h-50.086c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h31.979l-48.298 48.301c-2.929 2.929-2.929 7.678.001 10.607 1.464 1.464 3.384 2.196 5.303 2.196s3.839-.733 5.304-2.197l48.298-48.301v31.98c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-50.086c-.001-4.143-3.359-7.5-7.501-7.5z" />
    </svg>
  </IconStyled>
);

IconFullSize.defaultProps = iconDefaultProps;
IconFullSize.displayName = 'IconFullSize';

export default IconFullSize;
